module.exports = __webpack_public_path__ + "static/dark-logo-17-128fb806b9e277fd9edc539f9a82a863.png";